'use client';

import React, { useState, useEffect } from 'react';
import Breadcumbs from '@/components/Breadcumbs';
import Image from 'next/image';
import { FaPlus } from 'react-icons/fa';

const images = [
    // {
    //     src: "https://cdn.dotplus.in/Cloud/Aarogyam/gallary/aarogyam_gallery_img/DSC_8543.jpg?width=410&format=jpg",
    //     alt: "Modern Reception Area at HDNA Aarogyam Hospital"
    // },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/gallary/aarogyam_gallery_img/DSC_8652.jpg?width=410&format=jpg",
        alt: "Spacious Patient Waiting Lounge at HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/gallary/aarogyam_gallery_img/DSC_8791.jpg?width=410&format=jpg",
        alt: "State-of-the-Art Hospital Infrastructure – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/gallary/aarogyam_gallery_img/DSC_8732.jpg?width=410&format=jpg",
        alt: "Advanced Patient Ward Setup at HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/gallary/aarogyam_gallery_img/DSC_8761.jpg?width=410&format=jpg",
        alt: "High-Quality Medical Equipment and Facilities – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/2.png?width=410&format=jpg",
        alt: "OPD and IPD Services Icon – HDNA Aarogyam Hospital"
    },
    // {
    //     src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/3.png?width=410&format=jpg",
    //     alt: "Emergency and Trauma Care Icon – HDNA Aarogyam Hospital"
    // },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/5.png?width=410&format=jpg",
        alt: "Dialysis Unit Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/6.png?width=410&format=jpg",
        alt: "Cath Lab Services Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/8.png?width=410&format=jpg",
        alt: "Radiology and Imaging Services Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/9.png?width=410&format=jpg",
        alt: "Pathology and Lab Testing Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/10.png?width=410&format=jpg",
        alt: "24/7 Pharmacy Services Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/11.png?width=410&format=jpg",
        alt: "Cardiac Services Icon – HDNA Aarogyam Hospital"
    },
    {
        src: "https://cdn.dotplus.in/Cloud/Aarogyam/services/12.png?width=410&format=jpg",
        alt: "Specialized Renal HDU Services Icon – HDNA Aarogyam Hospital"
    },

];

const Gallery = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        document.body.classList.toggle('no-scroll', isOpen);
        return () => document.body.classList.remove('no-scroll');
    }, [isOpen]);

    const openModal = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };
    const closeModal = () => setIsOpen(false);
    const showPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };
    const showNext = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div>
            <Breadcumbs
                title="Gallery"
                items={[
                    { label: 'Home', href: '/' },
                    { label: 'Gallery' },
                ]}
            />
            <div className="container py-5">
                <div className="row g-4">
                    {images.map((img, index) => (
                        <div key={index} className="col-md-6 col-lg-4 col-sm-12">
                            <div className="gallery-item" onClick={() => openModal(index)}>
                                <Image src={img.src} alt={img.alt} className="img-fluid w-100" width={410} height={274} />
                                <div className="gallery-overlay">
                                    <span className="plus-icon"><FaPlus /></span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {isOpen && (
                    <div className="lightbox">
                        <span className="close-gallery" onClick={closeModal}>&times;</span>
                        <div className="lightbox-content">
                            <Image src={images[currentIndex].src} alt={images[currentIndex].alt} className="lightbox-img" width={410} height={274} />
                            <div className="lightbox-caption">
                                <span className="lightbox-title">Photo</span>
                                <span className="lightbox-count">{currentIndex + 1} of {images.length}</span>
                            </div>
                        </div>
                        <button className="css-gallery-prev" onClick={showPrev}>&#10094;</button>
                        <button className="css-gallery-next" onClick={showNext}>&#10095;</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Gallery;
